import XModal from "./components/CommonIndependent/XModal.vue";
import IModal from "./components/CommonIndependent/IModal.vue";
import BlockNotify from "./components/CommonIndependent/BlockNotify.vue";
import CertCommonInfo from "./components/CommonIndependent/CertCommonInfo.vue";
import CPCertificateSelect from "./components/CommonIndependent/CPCertificateSelect.vue";
import FileInput from "./components/CommonIndependent/FileInput.vue";
import FilesInput from "./components/CommonIndependent/FilesInput.vue";
import ModalInputText from "./components/CommonIndependent/ModalInputText.vue";
import SearchInput from "./components/CommonIndependent/SearchInput.vue";
import SearchSelect from "./components/CommonIndependent/SearchSelect.vue";
import SearchDate from "./components/CommonIndependent/SearchDate.vue";
import TablePage from "./components/CommonIndependent/TablePage.vue";
import UserMultiSelect from "./components/CommonIndependent/UserMultiSelect.vue";
import UserSelector from "./components/CommonIndependent/UserSelector.vue";
import XDataTable from "./components/CommonIndependent/XDataTable.vue";
import PdfModal from "./components/CommonIndependent/pdf/PdfModal.vue";
import PdfView from "./components/CommonIndependent/pdf/PdfView.vue";
import AppEventBus from "./utils/AppEventBus";
import DataFilters from "./utils/DataFilters";
import Helper from "./utils/Helper";
import XDropDown from "./components/ComponentsExtends/XDropDown.vue";
import InputText from "./components/ComponentsExtends/InputText.vue";
import Password from "./components/ComponentsExtends/Password.vue";
import TreeForParams from "./components/ComponentsExtends/TreeForParams.vue";
import TreeNodeForParams from "./components/ComponentsExtends/TreeNodeForParams.vue";
import Xapi from "./utils/xapi.ts";
import xTouchDirective from "./utils/xTouchDirective";
import Notifies from "./components/CommonIndependent/Notifies.vue";
import Settings from "./components/BackDepended/Settings.vue";
import CryptoPro from "./utils/cryptopro/cp_helper";
import GlobalEventBus, { EventsList } from "./utils/GlobalEventBus.ts";
import TreeTable from "./components/ComponentsExtends/TreeTable.vue";
import Accordion from "./components/ComponentsExtends/Accordion.vue";
import HelpButton from "./components/CommonIndependent/HelpButton.vue";
import ThemeSwitcher from "./components/CommonIndependent/ThemeSwitcher.vue";
import { get, set } from 'idb-keyval';
import dark_css from '!!css-loader!./assets/css/vela-blue/theme.css';
import light_css from '!!css-loader!./assets/css/mdc-light-indigo-no-outline/theme.css';
export { XModal, IModal, PdfModal, PdfView, XDataTable, UserSelector, UserMultiSelect, TablePage, SearchSelect, SearchInput, SearchDate, ModalInputText, FilesInput, CPCertificateSelect, BlockNotify, FileInput, CertCommonInfo, InputText, XDropDown, Password, TreeForParams, TreeNodeForParams, Helper, DataFilters, AppEventBus, Xapi, Notifies, Settings, CryptoPro, GlobalEventBus, EventsList, TreeTable, xTouchDirective, Accordion, HelpButton, ThemeSwitcher };
const plugin = {
  install: async (app, options) => {
    var _await$get2;

    if (!options) options = {
      cssLinks: {
        dark: dark_css,
        light: light_css
      }
    };
    app.directive('xtouch', xTouchDirective);
    GlobalEventBus.on(EventsList.ChangeTheme, async themeName => {
      var _options$cssLinks$the;

      if (themeName === 'auto') {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          GlobalEventBus.emit(EventsList.ChangeTheme, 'dark');
        } else {
          GlobalEventBus.emit(EventsList.ChangeTheme, 'light');
        }

        return;
      }

      set('xComponents', { ...(await get('xComponents')),
        nowTheme: themeName
      });
      const existsStyleElement = document.querySelector('#theme-link');

      if (existsStyleElement) {
        if (existsStyleElement.getAttribute('theme-name') === themeName) return;
      }

      console.log('Смена темы на: ' + themeName);
      const elementId = 'theme-link';
      const style = document.createElement('style');
      style.type = 'text/css';
      style.textContent = (_options$cssLinks$the = options.cssLinks[themeName]) !== null && _options$cssLinks$the !== void 0 ? _options$cssLinks$the : options.cssLinks.dark;
      style.addEventListener('load', () => {
        document.querySelectorAll('#theme-link').forEach(item => item.remove());
        style.setAttribute('id', elementId);
        style.setAttribute('theme-name', themeName);
      });
      document.head.appendChild(style);
    }); // Регистрация события смены темы в операционной системе

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', async event => {
      var _await$get;

      if ((_await$get = await get('xComponents')) !== null && _await$get !== void 0 && _await$get.auto_switch_theme) {
        if (event.matches) {
          GlobalEventBus.emit(EventsList.ChangeTheme, 'dark');
        } else {
          GlobalEventBus.emit(EventsList.ChangeTheme, 'light');
        }
      }
    }); // При загрузке плагина, сразу вызываем событие смены темы на нужную

    const autoswitch = (_await$get2 = await get('xComponents')) === null || _await$get2 === void 0 ? void 0 : _await$get2.auto_switch_theme;

    if (autoswitch) {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        GlobalEventBus.emit(EventsList.ChangeTheme, 'dark');
      } else {
        GlobalEventBus.emit(EventsList.ChangeTheme, 'light');
      }
    } else {
      var _xComponentsProps$now;

      const xComponentsProps = await get('xComponents');
      GlobalEventBus.emit(EventsList.ChangeTheme, (_xComponentsProps$now = xComponentsProps === null || xComponentsProps === void 0 ? void 0 : xComponentsProps.nowTheme) !== null && _xComponentsProps$now !== void 0 ? _xComponentsProps$now : 'dark');
    }
  }
};
export default plugin;